import { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { useNavigate, Link } from "react-router-dom";
import "../../assets/css/admin/register.css";

function Register() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
const [popup, setPopup] = useState({
  show: false,
  type: "",
  message: ""
});
  const register = async (e) => {
    e.preventDefault();

    if (!email || !password || !confirmPassword) {
      setMessage("Please fill all fields.");
      return;
    }

    if (password.length < 6) {
      setMessage("Password should be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);

   setPopup({
  show: true,
  type: "success",
  message: "Registration Successful!"
});

setTimeout(() => {

  navigate("/admin/login");

}, 2000);
    } catch (error) {
      setMessage(error.message.replace("Firebase: ", ""));
    }
  };

  return (
    <>
    {popup.show && (

  <div className={`luxury-popup ${popup.type}`}>

    <div className="popup-icon">
      ✓
    </div>

    <div className="popup-content">

      <h3>Success</h3>

      <p>{popup.message}</p>

    </div>

  </div>

)}
    <div className="register-page">
      <div className="register-card">
        <h2>Create Account</h2>
        <p className="subtitle">Register to continue</p>

        <form onSubmit={register}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          {message && <p className="error">{message}</p>}

          <button type="submit">Register</button>
        </form>

        <p className="bottom-text">
          Already have an account?
          <Link to="/admin/login"> Login</Link>
        </p>
      </div>
    </div>
    </>
  );
}

export default Register;